import apiClient from './apiClient';

const endpoint = '/empresa/';

const empresaService = {
  obtener: async () => {
    const resp = await apiClient.get(endpoint);
    // Puede devolver { results: [...] } (paginado) o una lista/objeto directo.
    return resp.data;
  },
  // Flags de configuración de la organización accesibles a cualquier usuario
  // autenticado (el detalle de empresa exige permiso de vista y el mecánico no lo tiene).
  obtenerConfiguracion: async () => {
    const resp = await apiClient.get(`${endpoint}configuracion/`);
    return resp.data;
  },
  crear: async (data) => {
    // Nota: cuando enviamos FormData, dejamos que el navegador/axios gestione el
    // Content-Type (boundary). Sobre-escribimos el header por defecto para que
    // no se envíe como application/json.
    const config = {};
    if (data instanceof FormData) {
      config.headers = { 'Content-Type': undefined };
    }
    const resp = await apiClient.post(endpoint, data, config);
    return resp.data;
  },
  actualizar: async (id, data) => {
    const config = {};
    if (data instanceof FormData) {
      config.headers = { 'Content-Type': undefined };
    }
    const resp = await apiClient.patch(`${endpoint}${id}/`, data, config);
    return resp.data;
  }
};

export default empresaService;
